import { UserProfile } from 'fitbeat.gym-core';
import { HeartRateStep } from 'fitbeat.models';
import React, { PureComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import {
  Button,
  ButtonTypes,
} from '../../components';
import Theme from '../../theme';
import {
  ConnectingLoaderIcon,
  ExclamationIcon,
} from '../../ui/components/Icons';
import { IAppStore } from '../reducer';
import {
  heartRateRecievedErrorSelector,
  isScanningBeltSelector, liveHeartRateSelector,
} from '../selectors/heartRateMonitorSelectors';
import { BluetoothServiceSingleton } from '../utils';
import { BLUETOOTH_SCAN_TIMEOUT, IBluetoothService } from '../utils/IBluetoothService';
import { MonitorActivationInstructions } from './MonitorActivationInstructions';
import { MonitorConnectionStatus } from './MonitorConnectionStatus';
import { MonitorConnectionSuccessful } from './MonitorConnectionSuccessful';

interface IProps {
  isScanningBelt: boolean;
  liveHeartRate: number | null;
  heartRateRecievedError: string | null;
  userProfile: UserProfile;
  heartRateScanAction: any;
  goToStep(step: HeartRateStep): void;
  closeModal(): void;
  testBelt(beltNumber: string): void;
}

export class TestHeartRateBelt extends PureComponent<IProps, {}> {
  public componentDidMount = () => {
    const { testBelt, userProfile } = this.props;
    testBelt(userProfile.heartRateMonitorIdentifier);
  }

  public render() {
    const { goToStep, closeModal, isScanningBelt, liveHeartRate,
      heartRateRecievedError, testBelt, userProfile } = this.props;
    return (
      <View style={styles.container}>
        {isScanningBelt && !heartRateRecievedError &&
          <MonitorConnectionStatus
            icon={<ConnectingLoaderIcon width={50} height={50} />}
            statusText='Trying to connect to monitor'
            statusActionText='Activate the monitor' />
        }
        {liveHeartRate && !isScanningBelt &&
          <MonitorConnectionSuccessful liveHeartRate={liveHeartRate} />
        }
        {heartRateRecievedError &&
          <MonitorConnectionStatus
            statusTextStyle={{ fontFamily: Theme.Custom600 }}
            statusText={heartRateRecievedError}
            icon={<ExclamationIcon width={50} height={50} />}
          />
        }
        <View style={styles.verticalSeparator} />
        <MonitorActivationInstructions />
        {liveHeartRate && !isScanningBelt &&
          <Button
            title={'Done'}
            onPress={closeModal}
            fontColor={Theme.WHITE}
            buttonType={ButtonTypes.NORMAL}
          />}
        {isScanningBelt &&
          <Button
            title={'Cancel Test'}
            onPress={() => goToStep(HeartRateStep.HAS_BELT)}
            fontColor={Theme.PRIMARY}
            buttonType={ButtonTypes.OUTLINE}
          />}
        {heartRateRecievedError &&
          <View style={styles.buttonContainer}>
            <Button
              title={'Retry'}
              onPress={() => testBelt(userProfile.heartRateMonitorIdentifier)}
              fontColor={Theme.PRIMARY}
              buttonType={ButtonTypes.OUTLINE}
              containerStyle={[styles.submitButtonContainer]}

            />
            <Button
              title={'Cancel Test'}
              onPress={() => goToStep(HeartRateStep.HAS_BELT)}
              fontColor={Theme.PRIMARY}
              buttonType={ButtonTypes.OUTLINE}
              containerStyle={[styles.submitButtonContainer]}
            />
          </View>
        }
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  buttonContainer: {
    flexDirection: 'column',
  },
  submitButtonContainer: {
    marginVertical: 5,
  },
  verticalSeparator: {
    borderBottomWidth: 1,
    borderBottomColor: Theme.GREY_MEDIUM_LIGHT,
  },
});

const mapStateToProps = (state: IAppStore) => ({
  isScanningBelt: isScanningBeltSelector(state),
  liveHeartRate: liveHeartRateSelector(state),
  heartRateRecievedError: heartRateRecievedErrorSelector(state),
});

const mapDispatchToProps = (dispatch: any, ownProps: IProps) => {
  return {
    testBelt: (beltNumber: string) => {
      dispatch(ownProps.heartRateScanAction(
        beltNumber,
        ownProps.userProfile,
        BluetoothServiceSingleton.getBluetoothService,
        BLUETOOTH_SCAN_TIMEOUT,
      ));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TestHeartRateBelt);
